export const NAME = 'CONSULTATION';

export const getConsultants = (store) => store[NAME].consultants || [];
